import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/plus.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle-outline.svg'
import _imports_2 from '@/app/ui/assets/svg/check-circle-border-green.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c7e19d22")

_pushScopeId("data-v-c7e19d22")
const _hoisted_1 = { class: "w-full flex py-3 flex-col gap-y-4 city-exclude-radio" }
const _hoisted_2 = {
  key: 0,
  class: "p-field-radiobutton gap-x-3 flex flex-row"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "radio-console",
  class: "cursor-pointer"
}, "Consolidator", -1)
const _hoisted_4 = {
  key: 1,
  class: "w-full flex flex-col gap-y-4 pl-8"
}
const _hoisted_5 = {
  key: 2,
  class: "p-field-radiobutton gap-x-3 flex flex-row"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "radio-sub-console",
  class: "cursor-pointer"
}, "Subconsolidator", -1)
const _hoisted_7 = {
  key: 3,
  class: "w-full flex flex-col gap-y-4 pl-8"
}
const _hoisted_8 = { class: "p-field-radiobutton gap-x-3 flex flex-row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "radio-vendor",
  class: "cursor-pointer"
}, "Vendor", -1)
const _hoisted_10 = {
  key: 4,
  class: "w-full flex flex-col gap-y-4 pl-8"
}
const _hoisted_11 = {
  key: 0,
  class: "px-4 py-3 border-t"
}
const _hoisted_12 = { class: "gap-x-2 justify-center items-center flex" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  alt: "plus",
  src: _imports_0
}, null, -1)
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "w-2/12" }
const _hoisted_16 = { class: "inline-flex gap-x-2 ml-2 w-1/12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_select_search = _resolveComponent("select-search")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_custom_dropdown, {
      value: _ctx.modelValue.name,
      placeholder: _ctx.$t('updateDelivery.form.selectPartner'),
      isDisabled: _ctx.disabled,
      isExpand: _ctx.isExpand,
      "onUpdate:isExpand": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isExpand = $event))
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.role === 'console')
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_RadioButton, {
                  onChange: _ctx.onChangeRadioValue,
                  id: "radio-console",
                  name: "console",
                  value: "console",
                  modelValue: _ctx.radioValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radioValue = $event))
                }, null, 8, ["onChange", "modelValue"]),
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          (_ctx.radioValue === 'console')
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_select_search, {
                  "server-side": false,
                  keyValue: "code",
                  keyName: "name",
                  options: _ctx.deliveredByConsoleSubConsoleOptions,
                  placeholder: _ctx.$t('updateDelivery.form.selectConsole'),
                  modelValue: _ctx.modelValue,
                  "onUpdate:modelValue": _ctx.onUpdateDeliveredBy
                }, null, 8, ["options", "placeholder", "modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.role === 'sub-console')
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_RadioButton, {
                  onChange: _ctx.onChangeRadioValue,
                  id: "radio-sub-console",
                  name: "sub-console",
                  value: "sub-console",
                  modelValue: _ctx.radioValue,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.radioValue = $event))
                }, null, 8, ["onChange", "modelValue"]),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (_ctx.radioValue === 'sub-console')
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_select_search, {
                  "server-side": false,
                  keyValue: "code",
                  keyName: "name",
                  options: _ctx.deliveredByConsoleSubConsoleOptions,
                  placeholder: _ctx.$t('updateDelivery.form.selectSubConsole'),
                  modelValue: _ctx.modelValue,
                  "onUpdate:modelValue": _ctx.onUpdateDeliveredBy
                }, null, 8, ["options", "placeholder", "modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_RadioButton, {
              onChange: _ctx.onChangeRadioValue,
              id: "radio-vendor",
              name: "vendor",
              value: "vendor",
              modelValue: _ctx.radioValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.radioValue = $event))
            }, null, 8, ["onChange", "modelValue"]),
            _hoisted_9
          ]),
          (_ctx.radioValue === 'vendor')
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_select_search, {
                  ref: "selectSearchVendor",
                  "server-side": true,
                  "is-loading": _ctx.loadingVendorList,
                  onFocus: _ctx.fetchDeliveryVendorOptions,
                  onFilter: _ctx.fetchDeliveryVendorOptions,
                  keyValue: "id",
                  keyName: "name",
                  options: _ctx.deliveredByVendorOptions,
                  placeholder: _ctx.$t('updateDelivery.form.selectVendor'),
                  modelValue: _ctx.modelValue,
                  "onUpdate:modelValue": _ctx.onUpdateDeliveredBy
                }, {
                  "footer-select": _withId(() => [
                    (!_ctx.loadingVendorList)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _withDirectives(_createVNode("div", null, [
                            _createVNode("button", {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleOpenAddVendor(true))),
                              style: {"border-color":"#d4d5d8"},
                              class: "border rounded-lg py-2 px-3 text-black-lp-300 cursor-pointer focus:outline-none"
                            }, [
                              _createVNode("span", _hoisted_12, [
                                _hoisted_13,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("updateDelivery.form.addVendor")), 1)
                              ])
                            ])
                          ], 512), [
                            [_vShow, !_ctx.openAddVendor]
                          ]),
                          _withDirectives(_createVNode("div", null, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("updateDelivery.form.add")), 1),
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.newVendorName = $event)),
                                class: "text-gray-lp-500 w-8/12 p-1.5 bg-white border border-gray-lp-400 rounded shadow-xs leading-tight focus:outline-none",
                                placeholder: _ctx.$t('updateDelivery.form.placeholderAdd'),
                                type: "text"
                              }, null, 8, ["placeholder"]), [
                                [_vModelText, _ctx.newVendorName]
                              ]),
                              _createVNode("div", _hoisted_16, [
                                _createVNode("img", {
                                  alt: "clear",
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearNewVendorName && _ctx.clearNewVendorName(...args))),
                                  class: "cursor-pointer",
                                  style: {"height":"20px","width":"20px"},
                                  src: _imports_1
                                }),
                                _createVNode("img", {
                                  alt: "check",
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitNewVendorName && _ctx.submitNewVendorName(...args))),
                                  class: "cursor-pointer",
                                  style: {"height":"20px","width":"20px"},
                                  src: _imports_2
                                })
                              ])
                            ])
                          ], 512), [
                            [_vShow, _ctx.openAddVendor]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["is-loading", "onFocus", "onFilter", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["value", "placeholder", "isDisabled", "isExpand"])
  ]))
})